import type { FilterOptionPercentSale as FilterOptionPercentSaleType } from '@providers/FilterProvider';
import { formatPercentSaleLabel } from '@utils';

import type { FilterOptionListProps } from '@/features/filter-product-list/filter/FilterOptionList';
import FilterOptionList from '@/features/filter-product-list/filter/FilterOptionList';

export type FilterOptionPercentSaleProps = Omit<
  FilterOptionListProps<FilterOptionPercentSaleType>,
  'filterOptionItemProps'
>;

const formatPercentSaleValue = (to: number, from?: number) => {
  return `${from || ''}:${to || ''}`;
};

const FilterOptionPercentSale = (props: FilterOptionPercentSaleProps) => {
  return (
    <FilterOptionList
      {...props}
      filterOptionItemProps={({ from, to, doc_count }) => ({
        value: formatPercentSaleValue(to, from),
        label: formatPercentSaleLabel(to, from),
        docCount: doc_count,
      })}
    />
  );
};

export default FilterOptionPercentSale;
